import FileTokens from 'endpoints/file-tokens'
import { toastr } from 'react-redux-toastr'
import { I18n } from 'react-redux-i18n'

export default class extends React.Component {
  constructor() {
    super();
    this.state = { loading: false, failUrl: null };
    this.onDownload = this.onDownload.bind(this);
  }

  onDownload(e) {
    e.preventDefault();
    if(this.props.disabled || this.state.loading) return;

    this.setState({ loading: true });
    FileTokens.get(this.props.type, this.props.id).then(url => {
      this.setState({ loading: false });
      let isFailed = !window.open(url, '_blank');
      if(isFailed) {
        toastr.warning('', {
          component: (
            <p className="download-link-blocked">
              {I18n.t('download_btn.blocked.title')}
              <a href={url} target="_blank">{I18n.t('download_btn.blocked.link')}</a>
            </p>
          ),
          timeOut: 20000
        });
      }
    }, () => this.setState({ loading: false }));
  }

  render() {
    if(this.props.link) {
      return (
        <a href="#" className={this.props.className} onClick={this.onDownload}>
          {this.props.children}
        </a>
      );
    } else {
      let disabled = this.props.disabled || this.state.loading;
      return (
        <button type="button" className={this.props.className} onClick={this.onDownload} disabled={disabled}>
          {this.props.children}
        </button>
      );
    }
  }
}
